// "Too easy / About right / Too hard" on the solved sheet (2026-11-02), so
// the weekday difficulty guides are tuned on more than one solver's feel.
// `crosswordRatings/<date>/<uid>` = { vote, seconds, clean, together, at },
// mine alone to read and write; scripts/difficulty-report.mjs reads them all
// with the admin key. Dailies only: the Giant has no weekday to tune.
import { ref as dbRef, get, set } from 'firebase/database';
import { db } from '@/firebase';

export const RATINGS_PATH = 'crosswordRatings';
export const VOTES = [
  { id: 'easy', label: 'Too easy' },
  { id: 'right', label: 'About right' },
  { id: 'hard', label: 'Too hard' },
];

export async function readMyRating(date, uid) {
  if (!db || !date || !uid) return null;
  try {
    const snap = await get(dbRef(db, `${RATINGS_PATH}/${date}/${uid}`));
    return snap.val()?.vote || null;
  } catch {
    return null;
  }
}

export function saveMyRating(date, uid, row) {
  if (!db || !date || !uid) return Promise.resolve();
  return set(dbRef(db, `${RATINGS_PATH}/${date}/${uid}`), { ...row, at: Date.now() });
}
